import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Loading from '@hellodarwin/core/lib/components/loading';
import Save from '@hellodarwin/icons/dist/icons/Save';
import Drawer from 'antd/es/drawer';
import { useTheme } from 'styled-components';
import { FormFillingDrawerHeader, FormFillingDrawerTitle } from './styles';
const GenericFormFillingDrawer = (props) => {
    const theme = useTheme();
    return (_jsx(Drawer, { open: props.open, onClose: props.onClose, width: props.width, title: _jsxs(FormFillingDrawerHeader, { children: [_jsx(FormFillingDrawerTitle, { children: _jsx(Typography, { elementTheme: "subtitle1", children: props.titleText }) }), _jsx(Button, { size: "circle", defaultStyle: theme.colors.white_1, onClick: props.onSave, disabled: props.loading, children: props.loading ? _jsx(Loading, { size: "small" }) : _jsx(Save, { size: 16 }) })] }), children: props.children }));
};
export default GenericFormFillingDrawer;
